import { Box } from "@mui/material";
import {useDropzone} from 'react-dropzone'
import { myConstants } from "../../shares/Constants";
import React from 'react';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { useUpdateClubLogoMutation } from "../../store/club/ClubApi"

export const dropZoneWidth   = 240;
export const dropZoneHeight  = 300;



/* 
 Das eigentliche (veränderte) Dropzone
 Objekt, welches auf die Eingabe wartet.
 Dieses hinterlegen wir mit dem aktuellen
 Bild, damit wir dieses direkt anzeigen können. 
 Sobald jemand die Dropzone verwenden, schalten
 wir dann das Bild um. 
*/
export function ClubLogo({year, club, size = 72}) {
  
  // Senden der Datei berücksichtigen...
  const [updateClubLogo] = useUpdateClubLogoMutation();
  const [clubLogo, setClubLogo] = React.useState(
    club.logo ? myConstants.baseURL.replace(/\/$/, '') + club.logo : null
  );



  // Aufbauen des reagierens auf abgelegte Dateien
  const onDropAccepted = React.useCallback(
    (acceptedFiles) => {
      acceptedFiles.forEach(
        file => 
        {
          console.log(file);
          // wir bereiten die Form-Daten vor, damit danach
          // die Datei hochgeladen werden kann:
          updateClubLogo( 
            { tournament_id: year, club_id : club.id, file : file }
          ).unwrap(            
          ).then(  
           (payload) => setClubLogo(myConstants.baseURL.replace(/\/$/, '') + payload.logo)                     
          ).catch(
            (error) => console.error(error)
          );
        }
      );    
    }, [year, club.id, updateClubLogo, setClubLogo]
  );


  // Aufbauen der eigentlichen Dropzone
  const {
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject
  } = useDropzone(
    {
      multiple: false, 

      accept: 
      {
        'image/jpeg': [],
        'image/png': []
      },
      useFsAccessApi: false,
      onDropAccepted: onDropAccepted,
    }
  );

  const borderColor = 
    isDragAccept ? '#00e676' 
    : isDragReject ? '#ff1744'
    : isFocused ? '#2196f3'
    : '#bdbdbd';

/*
  // Größe des Bildes ermitteln - sollte es Höher als Breit sein, 
  // dann wechseln wir die Rendergröße  
  const [backgroundSize, setBackgroundSize] = React.useState("");

  // Einmalig im Hintergurnd ermitteln...
  React.useEffect( () => 
    {
      let img = new Image();
      img.src = clubLogo;
      img.onload = () => 
      {
        if (img.height > dropZoneHeight)
          if (img.width > dropZoneWidth)
            if (img.width > img.height)
              setBackgroundSize(String(dropZoneWidth).toString() + "px auto");
            else
              setBackgroundSize("auto " + String(dropZoneHeight).toString() + "px");
          else
            setBackgroundSize("auto " + String(dropZoneHeight).toString() + "px");          
        else
          if (img.width > dropZoneWidth) 
            setBackgroundSize(String(dropZoneWidth).toString() + "px auto");
          else
            if (img.width > img.height)
              setBackgroundSize(String(dropZoneWidth).toString() + "px auto");
            else
              setBackgroundSize("auto " + String(dropZoneHeight).toString() + "");
      } 
    }, [clubLogo, setBackgroundSize]
  );
*/
  
 return (
    <Box
      {...getRootProps()}
      sx={{
        width: size, height: size,
        borderRadius: 2,
        flexShrink: 0,
        cursor: 'pointer',
        overflow: 'hidden',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        ...(clubLogo ? {
          backgroundImage: `url(${clubLogo})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        } : {
          border: `2px dashed ${borderColor}`,
          bgcolor: 'action.hover',
        }),
      }}
    >
      <input {...getInputProps()} />
      {!clubLogo && (
        <UploadFileIcon sx={{ color: 'text.disabled', fontSize: size * 0.45 }} />
      )}
    </Box>
  );
}
 